import { useReferralsContext } from '@user/components/Referrals/context'
import {
  ReferralTypes,
  setReferralActionCreator,
  setReferralTypeActionCreator,
} from '@user/components/Referrals/state'
import { Props as ActionButtonProps } from '../ReferralActionButton'
import { ReferralFormVariant } from '@user/components/Referrals/components/UpdateReferral/TidalUpdateReferral'

type Props = Pick<ActionButtonProps, 'onClick' | 'referral'> & {
  formVariant: ReferralFormVariant
}

export function useHandlers(props: Props) {
  const { onClick, referral, formVariant } = props

  const [, dispatch] = useReferralsContext()

  function handleClick() {
    dispatch(setReferralActionCreator(referral || null))
    onClick()
    if (formVariant === ReferralFormVariant.Inline) {
      const source = 'None' as ReferralTypes
      dispatch(setReferralTypeActionCreator(source))
    }
  }

  return { handleClick } as const
}
